import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';
import { getSecurityAuditSummaryQueryKey } from '@/modules/api/codegen';
import { selectPasswordSecrets } from '@/modules/secrets/services/selectors/list';

// Every flow that changes secrets (create, edit, delete, import, dismiss) ends in the Redux store, so
// watching it keeps the counts fresh without each saga knowing about the summary.
export const useRefreshSecurityAuditSummary = () => {
    const queryClient = useQueryClient();
    const passwordSecrets = useAppSelector(selectPasswordSecrets, shallowEqual);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;

            return;
        }

        void queryClient.invalidateQueries({ queryKey: getSecurityAuditSummaryQueryKey() });
    }, [passwordSecrets, queryClient]);
};
